<div class="main">
  <div class="info">
    <h2>Casillas de verificación</h2>
    <p>Pueden incluirse campos en el documento a editar por los firmantes.</p>
  </div>
  <app-formularios-firmante *ngFor="let tipo of mostrarFirmantes" [firmante]="tipo" (firmanteSeleccionado)="seleccionarFirmante($event)"></app-formularios-firmante>

</div>

